var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAllMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93735 7.92905L10.6374 10.6291M13.4374 10.6291L16.1374 7.92905M7.93735 16.1291L10.6374 13.4291M13.4374 13.4291L16.1374 16.1291M8.03735 7.52905C8.03735 7.8052 7.8135 8.02905 7.53735 8.02905C7.26121 8.02905 7.03735 7.8052 7.03735 7.52905C7.03735 7.25291 7.26121 7.02905 7.53735 7.02905C7.8135 7.02905 8.03735 7.25291 8.03735 7.52905ZM17.0374 7.52905C17.0374 7.8052 16.8135 8.02905 16.5374 8.02905C16.2612 8.02905 16.0374 7.8052 16.0374 7.52905C16.0374 7.25291 16.2612 7.02905 16.5374 7.02905C16.8135 7.02905 17.0374 7.25291 17.0374 7.52905ZM8.03735 16.5291C8.03735 16.8052 7.8135 17.0291 7.53735 17.0291C7.26121 17.0291 7.03735 16.8052 7.03735 16.5291C7.03735 16.2529 7.26121 16.0291 7.53735 16.0291C7.8135 16.0291 8.03735 16.2529 8.03735 16.5291ZM17.0374 16.5291C17.0374 16.8052 16.8135 17.0291 16.5374 17.0291C16.2612 17.0291 16.0374 16.8052 16.0374 16.5291C16.0374 16.2529 16.2612 16.0291 16.5374 16.0291C16.8135 16.0291 17.0374 16.2529 17.0374 16.5291ZM14.0374 12.0291C14.0374 13.1336 13.1419 14.0291 12.0374 14.0291C10.9328 14.0291 10.0374 13.1336 10.0374 12.0291C10.0374 10.9245 10.9328 10.0291 12.0374 10.0291C13.1419 10.0291 14.0374 10.9245 14.0374 12.0291Z",
    stroke: "#3362FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0374 3.02905H5.03735C3.93278 3.02905 3.03735 3.92448 3.03735 5.02905V19.0291C3.03735 20.1336 3.93278 21.0291 5.03735 21.0291H19.0374C20.1419 21.0291 21.0374 20.1336 21.0374 19.0291V5.02905C21.0374 3.92448 20.1419 3.02905 19.0374 3.02905Z",
    stroke: "#3362FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAllMenu);
export default __webpack_public_path__ + "static/media/icon-all-menu.af26e76b7b2f7251fa8e4a55e9905988.svg";
export { ForwardRef as ReactComponent };